export interface BookDetail {
  childName: string,
  childAge: number,
  childGender: string,
  topic: string,
  learning: string,
  contextKeywords: string[],
};

export interface BookContent {
  title: string,
  text: string[]
};

export interface BookContentWithTopic extends BookContent {
  topic?: string,
};

export interface BookIllustrations {
  titleIllustrations: string[],
  textIllustrations: string[][]
};

export interface BookWithIllustrations {
  title: string,
  titleIllustration: string,
  text: string[],
  textIllustrations: string[]
};

export interface Job {
  jobId: string
};

export interface JobStatus<T> {
  finished: boolean,
  success: boolean,
  data: T | undefined,
  error: string | undefined,
};

export type Language = 'en' | 'de';
export const LANGUAGES: Map<Language, string> = new Map([ ['en', 'English 🇺🇸'], ['de', 'Deutsch 🇩🇪'] ]);
export const DEFAULT_LANGUAGE = 'en';

export interface TextData {
  'en': { [name: string]: string },
  'de': { [name: string]: string },
};

export interface LanguageContextData {
  language: Language,
  setLanguage: (language: Language) => void,
};

export interface ProceedableProps {
  proceed: () => void,
};